import { EventEmitter, Component, Output, Input, ViewEncapsulation } from '@angular/core';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';

@Component({
  selector: 'eg-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  providers: [...ValueAccessorUtil.getValueAccessorProvider(ToggleComponent)],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false,
})
export class ToggleComponent extends AbstractValueAccessorComponent<string | number> {
  @Input() isChecked = true;
  @Input() disabled = false;
  @Output() changes: EventEmitter<boolean> = new EventEmitter<boolean>();

  public onChanged(event: ToggleSwitchChangeEvent) {
    this.changes.emit(event.checked);
  }
}
